import { connect } from 'react-redux';
import { requestBooking, editBid, addBidNote, sendBid, saveBidDetailsRates, requestBidDetails, addAnswers, requestAnswers,addNotesBrand,getNotesBrand, changeBrandStatus, updateHotelContacts, deleteHotelContacts } from '../modules/booking';

import BookingDetail from '../components/BookingDetail';


const mapDispatchToProps = {
  requestBooking,
  editBid,
  addBidNote,
  sendBid,
  saveBidDetailsRates,
  requestBidDetails,
  addAnswers,
  requestAnswers,
  addNotesBrand,
  getNotesBrand,
  changeBrandStatus,
  updateHotelContacts,
  deleteHotelContacts,
};

const mapStateToProps = (state, ownProps) => ({
  hasError: state.booking.selectedBooking.hasError,
  isFetching: state.booking.selectedBooking.isFetching,
  needFetch: state.booking.selectedBooking.needFetch,
  request: state.booking.selectedBooking.request,
  id: state.booking.selectedBooking.id,
  user: state.auth.profile.user,
  detail: ownProps.params.detail,
  selectedAnswers: state.booking.selectedAnswers,
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingDetail);



// WEBPACK FOOTER //
// src/routes/booking/containers/BookingDetailContainer.js